import styled from 'styled-components';
import { toSocialHref } from '@peloton/external-links/models';
import { Links } from '@peloton/links';
import { gray4, slate1 } from '@engage/colors/base';
import { spaces } from '@engage/styles/spaces';
import { link1, link3 } from '@engage/typography/links';
import * as Icons from './icons';

const SocialLink: React.FC<React.PropsWithChildren<LinkProps>> = props => (
  <LinkWrapper>
    <StyledLink
      href={props.href}
      target="_blank"
      rel="noopener"
      darkTheme={props.darkTheme}
      aria-label={props.label}
    >
      {props.children}
    </StyledLink>
  </LinkWrapper>
);

const StyledLink = styled.a<{ darkTheme: boolean }>`
  ${props => (props.darkTheme ? link3 : link1)}
  fill:${props => (props.darkTheme ? gray4 : slate1)};
`;

const LinkWrapper = styled.li`
  display: inline-block;
  & + & {
    margin-left: ${spaces.large}px;
  }
`;

const SocialLinks: React.FC<React.PropsWithChildren<{ darkTheme?: boolean }>> = ({
  darkTheme = false,
}) => (
  <ul>
    <SocialLink
      darkTheme={darkTheme}
      href={toSocialHref(Links.getFacebookLink())}
      label={'Facebook'}
    >
      <Icons.Facebook />
    </SocialLink>
    <SocialLink
      darkTheme={darkTheme}
      href={toSocialHref(Links.instagram)}
      label={'Instagram'}
    >
      <Icons.Instagram />
    </SocialLink>
    <SocialLink
      darkTheme={darkTheme}
      href={toSocialHref(Links.twitter)}
      label={'Twitter'}
    >
      <Icons.Twitter />
    </SocialLink>
    <SocialLink
      darkTheme={darkTheme}
      href={toSocialHref(Links.youtube)}
      label={'Youtube'}
    >
      <Icons.Youtube />
    </SocialLink>
  </ul>
);

type LinkProps = {
  href: string;
  darkTheme: boolean;
  label: string;
};

export default SocialLinks;
